import React from "react";
import { compositeKeyString } from "../../util/panel";
import { injectIntl } from "react-intl";

function PanelTitle(props) {
  const title = compositeKeyString(
    props.compositeKey,
    " / ",
    true,
    props.intl.formatMessage
  );
  return <div className="panel-title">{title}</div>;
}

export default injectIntl(PanelTitle);
